import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardHeader, CircularProgress, useTheme } from '@material-ui/core';
import { getDiasSemanaMaisVisitantes } from '../../../../../services/DashboardService';
import Chart from 'react-apexcharts';
import Grid from '@material-ui/core/Grid';


const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 20,
    minHeight: 400
  },
  chartContainer: {
    minHeight: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const GraficoDiasSemanaMaisVisitantes = props => {
  const { className, ...rest } = props;
  const theme = useTheme();
  const [modalidadesMaisUsadas, setModalidadesMaisUsadas] = useState([]);
  const [mostrarProgress, setMostrarProgress] = useState(true);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);
  const [labels, setLabels] = useState([]);
  const [quantidades, setQuantidades] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    try {
      getDados();
    }
    catch (e) {

    }
  }, []);

  async function getDados() {
    try {
      setMostrarProgress(true);
      let dados = await getDiasSemanaMaisVisitantes();
      if (dados.isSuccess) {
        setMostrarProgress(false);
        setModalidadesMaisUsadas(dados.result);
        let novasLabels = [];
        let novasQuantidades = [];
        dados.result.map(diaSemana => {
          novasLabels.push([diaSemana.nomeDiaSemana]);
          novasQuantidades.push(diaSemana.valorTotalDiaSemana);
        });
        setLabels(novasLabels);
        setQuantidades(novasQuantidades);

      } else {
        setMostrarProgress(false);
        setMostrarAlertaErro(true);
      }
    } catch (e) {
      setMostrarProgress(false);
      setMostrarAlertaErro(true);
    }
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      elevation={3}
    >
      <CardHeader
        title="Dias da semana com maior presença de visitantes"
      />
      <CardContent
      >
        <Grid
          container
        >
          {
            mostrarProgress &&
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'center',
                height: 400
              }}
            >
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  height: 400,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <div className={classes.chartContainer}>
                  <CircularProgress
                  />
                </div>
              </Grid>
            </Grid>
          }
          {
            !mostrarProgress &&
            <Grid
              item
              md={12}
              xs={12}

            >
              <div className={classes.chartContainer}>
                <Chart
                  options={{
                    chart: {
                      id: 'graficoDiasSemanaMaisVisitantes',
                      group: 'social',
                      type: 'area',
                      height: 350,
                      toolbar: {
                        show: false
                      },
                    },
                    dataLabels: {
                      enabled: false
                    },
                    markers: {
                      size: 6,
                    },
                    colors: [theme.palette.info.main],
                    fill: {
                      colors: [theme.palette.info.main]
                    },
                    yaxis: {
                      labels: {
                        formatter: function (val) {
                          return val;
                        },
                        minWidth: 20,
                      },
                      title: {
                        text: 'Quantidade'
                      },
                    },
                    xaxis: {
                      type: 'category',
                      categories: labels,
                    },
                    tooltip: {
                      shared: true,
                      y: {
                        show: true,
                        formatter: function (val) {
                          return val
                        }
                      },
                      x: {
                        show: true,
                        formatter: function(val) {
                          return val
                        }
                      }
                    },

                  }}
                  type={'area'}
                  series={[{
                    name: 'Quantidade',
                    data: quantidades
                  }]}
                  height={400}
                />
              </div>
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

GraficoDiasSemanaMaisVisitantes.propTypes = {
  className: PropTypes.string
};

export default GraficoDiasSemanaMaisVisitantes;
